import React from "react";
import { IDataTableColumn } from "react-data-table-component";
import { intComma } from "humanize-plus";
import { CapacitiesRow } from "../../api";
import * as Service from "../../services/usage_based_capacity/select";
import { HeadCell } from "../../components/table/sortableTable";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";

const optionValue = [100, 90, 80, 70, 60, 50, 40, 30, 20, 10];

// should delete?
export const columns = [
    {
        name: "営業所",
        selector: "officeName",
        sortable: true,
        grow: 4,
    },
    {
        name: "乗務員",
        selector: "driverName",
        sortable: true,
        grow: 3,
    },
    {
        name: "利用開始日",
        selector: "startedDate",
        sortable: true,
        format: (r) => {
            return r.startedDate;
        },
        grow: 2,
    },
    {
        name: "上限金額",
        selector: (r) => {
            if (r.capPrice) {
                return r.capPrice;
            }
            return Infinity;
        },
        sortable: true,
        right: true,
        format: (r) => {
            return r.capPrice ? intComma(r.capPrice) : "上限なし";
        },
        grow: 2,
    },
    {
        name: "上限回数",
        selector: (r) => {
            if (r.capTrips! > 0) {
                return r.capTrips;
            }
            return Infinity;
        },
        sortable: true,
        right: true,
        format: (r) => {
            return r.capTrips ? intComma(r.capTrips) : "上限なし";
        },
        grow: 2,
    },
    {
        name: "",
        sortable: false,
        cell: function UpdateCapacityCell(r) {
            return (
                <UpdateCapacitySelector
                    key={r.driverId}
                    {...r}
                ></UpdateCapacitySelector>
            );
        },
        grow: 2,
    },
] as IDataTableColumn<CapacitiesRow>[];

export const headCells: HeadCell[] = [
    {
        label: "営業所",
        id: "officeName",
        numeric: false,
        grow: 4,
    },
    {
        label: "乗務員",
        id: "driverName",
        numeric: false,
        grow: 3,
    },
    {
        label: "利用開始日",
        id: "startedDate",
        numeric: false,
        format: (r) => {
            return r;
        },
        grow: 2,
    },
    {
        label: "上限金額",
        id: "capPrice",
        numeric: false,
        align: "right",
        format: (r) => {
            return r ? `${intComma(r)}円` : "上限なし";
        },
        grow: 2,
    },
    {
        label: "上限回数",
        id: "capTrips",
        numeric: true,
        headerAlignRight: true,
        align: "right",
        format: (r) => {
            return r && r > 0 ? intComma(r) : "上限なし";
        },
        grow: 2,
    },
    {
        label: "",
        id: "driverId",
        numeric: false,
        cell: function UC(r: any, row: any) {
            return (
                <UpdateCapacitySelector key={r} {...r}></UpdateCapacitySelector>
            );
        },
        grow: 2,
    },
];

export const UpdateCapacitySelector = (props: CapacitiesRow): JSX.Element => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    function onSelect(e) {
        console.debug("UpdateCapacitySelector selection", e);
        setAnchorEl(null);
    }

    function onSelectNoLimit() {
        Service.updateCapacities(props.officeId, props.driverId, -1);
    }

    const options = [
        <MenuItem key={0} onClick={onSelectNoLimit}>
            上限なし
        </MenuItem>,
    ] as JSX.Element[];
    options.push(
        ...optionValue.map((n) => {
            function onSelectLimit() {
                Service.updateCapacities(props.officeId, props.driverId, n);
            }
            return (
                <MenuItem key={n} href="#" onClick={onSelectLimit}>
                    {n}
                </MenuItem>
            );
        })
    );

    return (
        <>
            <Button
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
            >
                更新する
            </Button>
            <Menu
                id={`capacity-update-capacity-dropdown-${props.driverId}`}
                anchorEl={anchorEl}
                open={open}
                onClose={onSelect}
            >
                {options}
            </Menu>
        </>
    );
};
